import { every, isEmpty } from 'lodash';

export const isEmptyObject = (obj) => {
  return every(obj, (v) => isEmpty(v));
};

export const validateNumber = (number, field = 'field') => {
  if (!number) {
    return `${field} is required`;
  }

  // check if number is a number using regex
  if (!/^\d+$/.test(number)) {
    return `${field} must be a number`;
  }
};

export function toCamelCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const downloadFile = (url, fileName = 'sample') => {
  const a = document.createElement('a');
  a.class = 'download-file';
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const validateBankName = (bankName) => {
  // Check if bankName is a non-empty string
  if (typeof bankName !== 'string' || bankName.trim().length === 0) {
    return 'Bank name must be a non-empty string';
  }
  return '';
};

export const validateAccountNo = (accountNo) => {
  // must be 10 digits
  const accountNoRegex = /^[0-9]{10}$/;
  return accountNo.toString().match(accountNoRegex) ? '' : 'Enter valid account number';
};

export const validateAccountHolderName = (accountHolderName) => {
  // Check if accountHolderName is a non-empty string
  if (typeof accountHolderName !== 'string' || accountHolderName.trim().length === 0) {
    return 'Account holder name must be a non-empty string';
  }
  return '';
};

//valid cin number

export const validateCinNumber = (cinNumber) => {
  // must be number
  const cinNumberRegex = /^[0-9]+$/;
  return cinNumber.toString().match(cinNumberRegex) ? '' : 'Enter valid cin number';
};

//iban number
export const validateIbanNumber = (ibanNumber) => {
  // Check if ibanNumber is a non-empty string
  if (typeof ibanNumber !== 'string' || ibanNumber.trim().length === 0) {
    return 'Iban number must be a non-empty string';
  }
  return '';
};

//swift code
export const validateSwiftCode = (swiftCode) => {
  const swiftCodeRegex = /^[0-9]+$/;
  return swiftCode.toString().match(swiftCodeRegex) ? '' : 'Enter valid swift code';
  return '';
};

//branch name
export const validateBranchName = (branchName) => {
  // Check if branchName is a non-empty string
  if (typeof branchName !== 'string' || branchName.trim().length === 0) {
    return 'Branch name must be a non-empty string';
  }
  return '';
};

export const validateName = (name) => {
  if (typeof name !== 'string' || name.trim().length === 0) {
    return 'Name must be a non-empty string';
  }
  return '';
};

export const validateNationalNo = (nationalNo) => {
  // must be 9 digits
  const nationalNoRegex = /^[0-9]{9}$/;
  return nationalNo.match(nationalNoRegex) ? '' : 'Enter valid national number';
};

export const validateStageName = (stageName) => {
  //not empty // Check if  is a non-empty string
  if (typeof stageName !== 'string' || stageName.trim().length === 0) {
    return 'Stage name must be a non-empty string';
  }
  return '';
};

export const validateDate = (date?: Date) => {
  if (!date) {
    return 'Date is required';
  }

  const today = new Date();
  const birthDate = new Date(date);

  const age = today.getFullYear() - birthDate.getFullYear();

  if (age < 18 || (age === 18 && today.getMonth() < birthDate.getMonth()) || age > 100) {
    return 'Your age is not valid';
  }

  return '';
};

export const validateCountry = (country) => {
  // Check if country is a non-empty string
  if (typeof country !== 'string' || country.trim().length === 0) {
    return 'Country must be a non-empty string';
  }
  return '';
};

